export default __webpack_public_path__ + "static/media/gallery-5.e5b4abf7.jpg";